(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lume-flex-tones"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lume-flex-preview')) {
    customElements.define('lume-flex-preview', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.listeners?.abort();
        this.initialized = false;
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.controls = this.querySelector('.lume-tones__controls');
        this.buttons = Array.from(this.querySelectorAll('[data-tone-index][type="button"]'));
        this.panels = Array.from(this.querySelectorAll('[data-tone-panel]'));
        this.status = this.querySelector('.lume-tones__status');
        if (!this.controls || !this.status || this.buttons.length !== 3 || this.panels.length !== 3) return;
        this.initialized = true;
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.activeIndex = Math.min(2, Math.max(0, Number(this.dataset.activeIndex) || 0));
        this.panels.forEach((panel, index) => {
          const image = panel.querySelector('img');
          if (!image) {
            panel.dataset.imageFailed = 'true';
            return;
          }
          image.addEventListener('error', () => this.imageFailed(panel, index), options);
          if (image.complete && image.naturalWidth === 0) this.imageFailed(panel, index, false);
        });
        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-tone-index]');
          if (!button || !this.buttons.includes(button)) return;
          this.selectTone(Number(button.dataset.toneIndex));
        }, options);
        this.controls.addEventListener('keydown', (event) => {
          const button = event.target.closest('button[data-tone-index]');
          if (!button || !this.buttons.includes(button)) return;
          let index = Number(button.dataset.toneIndex);
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (index + 1) % this.buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (index + this.buttons.length - 1) % this.buttons.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.buttons.length - 1;
          else return;
          event.preventDefault();
          this.buttons[index].focus();
          this.selectTone(index);
        }, options);
        this.renderSelection(false);
        this.controls.hidden = false;
        const instruction = this.querySelector('[data-switcher-instruction]');
        if (instruction) instruction.hidden = false;
        this.classList.add('is-ready');
      }

      imageFailed(panel, index, announce = true) {
        panel.dataset.imageFailed = 'true';
        const image = panel.querySelector('img');
        const message = panel.querySelector('[data-image-error]');
        if (image) image.hidden = true;
        if (message) message.hidden = false;
        if (announce && index === this.activeIndex) this.announceSelection();
      }

      selectTone(index) {
        if (!Number.isInteger(index) || index < 0 || index >= this.panels.length || index === this.activeIndex) return;
        this.activeIndex = index;
        this.dataset.activeIndex = String(index);
        this.renderSelection(true);
      }

      renderSelection(announce) {
        this.buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.activeIndex)));
        this.panels.forEach((panel, index) => { panel.hidden = index !== this.activeIndex; });
        const image = this.panels[this.activeIndex].querySelector('img');
        if (image) image.loading = 'eager';
        if (announce) this.announceSelection();
      }

      announceSelection() {
        const panel = this.panels[this.activeIndex];
        const error = panel.dataset.imageFailed === 'true' ? panel.querySelector('[data-image-error]')?.textContent.trim() : '';
        this.status.textContent = [this.buttons[this.activeIndex].dataset.announcement, error].filter(Boolean).join(' ');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lume-project-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lume-project-carousel')) {
    class LumeProjectCarousel extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.current = this.querySelector('[data-current]');
        this.last = this.querySelector('[data-last]');
        this.range = this.querySelector('[data-range]');
        this.status = this.querySelector('[data-status]');
        this.activeIndex = 0;
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.queueUpdate(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => this.onKeydown(event), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.goTo(index, false);
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.track);
        this.classList.add('is-ready');
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.announcementTimer);
        this.controller = null;
      }

      queueUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        const viewport = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const rectangles = this.slides.map((slide) => slide.getBoundingClientRect());
        const starts = rectangles.map((rect) => rtl ? viewport.right - rect.right : rect.left - viewport.left);
        this.activeIndex = starts.reduce((best, distance, index) => Math.abs(distance) < Math.abs(starts[best]) ? index : best, 0);
        const fullyVisible = rectangles.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.left >= viewport.left - 2 && rect.right <= viewport.right + 2);
        const first = fullyVisible.length ? fullyVisible[0].index + 1 : this.activeIndex + 1;
        const last = fullyVisible.length ? fullyVisible[fullyVisible.length - 1].index + 1 : first;
        const atStart = starts[0] >= -2;
        const lastRect = rectangles[rectangles.length - 1];
        const atEnd = rtl ? lastRect.left >= viewport.left - 2 : lastRect.right <= viewport.right + 2;
        if (this.previous) this.previous.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
        if (this.current) this.current.textContent = first;
        if (this.last) this.last.textContent = last;
        if (this.range) this.range.hidden = first === last;
        clearTimeout(this.announcementTimer);
        this.announcementTimer = setTimeout(() => {
          const template = first === last ? this.dataset.statusOne : this.dataset.statusRange;
          const message = template.replace('[first]', first).replace('[last]', last).replace('[total]', this.slides.length);
          if (this.status && this.status.textContent !== message) this.status.textContent = message;
        }, 180);
      }

      move(direction) {
        this.goTo(this.activeIndex + direction);
      }

      goTo(index, animate = true) {
        const target = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
        const viewport = this.track.getBoundingClientRect();
        const rectangle = target.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = rtl ? rectangle.right - viewport.right : rectangle.left - viewport.left;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.track.scrollLeft + distance, behavior: animate && !reducedMotion ? 'smooth' : 'auto' });
      }

      onKeydown(event) {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : this.slides.length - 1);
        }
      }
    }
    customElements.define('lume-project-carousel', LumeProjectCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solulu-category-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PAGE_SIZE = 24;
  const escapeText = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  const normalise = (value) => String(value || '').toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim();
  const format = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`[${key}]`, value), text);
  const initialise = async (root) => {
    if (root.dataset.ready || root.dataset.catalogueMode !== 'full') return;
    root.dataset.ready = 'true';
    const labels = JSON.parse(root.querySelector('[data-catalogue-strings]').textContent);
    const loading = root.querySelector('[data-load]');
    try {
      const response = await fetch(root.dataset.catalogueUrl, { credentials: 'omit' });
      if (!response.ok) throw new Error('catalogue unavailable');
      const data = await response.json();
      if (!Array.isArray(data.products) || data.products.length !== data.total) throw new Error('catalogue invalid');
      const form = root.querySelector('[data-filters]');
      const products = data.products.map((product) => ({ ...product, search: normalise([product.title, product.model, product.categoryLabel, ...(product.finish || []), ...(product.mounting || [])].join(' ')) }));
      const controls = Object.fromEntries(['q', 'sort', 'department', 'group', 'category', 'finish', 'mounting'].map((name) => [name, form.elements.namedItem(name)]));
      let page = 1;
      let filtered = [];
      const selectOptions = (control, items, allLabel, value) => {
        control.innerHTML = `<option value="">${escapeText(allLabel)}</option>` + items.map((item) => `<option value="${escapeText(item.value)}">${escapeText(item.label)}</option>`).join('');
        control.value = items.some((item) => item.value === value) ? value : '';
      };
      selectOptions(controls.department, data.departments.map((department) => ({ value: department.id, label: `${department.label} (${department.count})` })), labels.all_departments, '');
      const updateFacets = () => {
        const department = controls.department.value;
        const groups = data.groups.filter((group) => !department || group.department === department);
        selectOptions(controls.group, groups.map((group) => ({ value: group.id, label: `${group.label} (${group.count})` })), labels.all_groups, controls.group.value);
        root.querySelector('[data-groups]').innerHTML = groups.map((group) => `<button type="button" data-group="${escapeText(group.id)}" aria-pressed="${group.id === controls.group.value}">${escapeText(group.label)} <span>${group.count}</span></button>`).join('');
        const selectedCategory = controls.category.value;
        const categories = data.categories.filter((category) => (!department || category.department === department) && (!controls.group.value || category.group === controls.group.value));
        root.querySelector('[data-type-filter]').hidden = !controls.group.value || categories.length < 2;
        selectOptions(controls.category, categories.map((category) => ({ value: category.id, label: `${category.label} (${category.count})` })), labels.all_categories, selectedCategory);
        const scope = products.filter((product) => (!department || product.department === department) && (!controls.group.value || product.group === controls.group.value) && (!controls.category.value || product.category === controls.category.value));
        ['finish', 'mounting'].forEach((name) => {
          const counts = new Map();
          scope.forEach((product) => product[name].forEach((value) => counts.set(value, (counts.get(value) || 0) + 1)));
          selectOptions(controls[name], [...counts].sort((a, b) => a[0].localeCompare(b[0])).map(([value, count]) => ({ value, label: `${value} (${count})` })), name === 'finish' ? labels.all_finishes : labels.all_mountings, controls[name].value);
        });
      };
      const setHash = () => {
        const params = new URLSearchParams();
        for (const [name, control] of Object.entries(controls)) if (control.value && !(name === 'sort' && control.value === 'az')) params.set(name, control.value);
        if (page > 1) params.set('page', page);
        history.replaceState(null, '', `${location.pathname}${location.search}${params.size ? `#${params}` : ''}`);
      };
      const productCard = (product) => {
        let imageUrl = '';
        try {
          const url = new URL(product.image || '');
          if (url.protocol === 'https:' && url.hostname === 'cdn.shopify.com') { url.searchParams.set('width', '500'); imageUrl = url.href; }
        } catch {}
        const media = imageUrl ? `<img src="${escapeText(imageUrl)}" alt="${escapeText(product.title)}" width="500" height="500" loading="lazy">` : `<span>${escapeText(labels.product_image_missing)}</span>`;
        return `<article class="sc-product"><div class="sc-product-image">${media}</div><div class="sc-product-content"><p class="sc-product-category">${escapeText(product.categoryLabel)}</p><h3>${escapeText(product.title)}</h3><p class="sc-product-model">${escapeText(labels.model_label)}: ${escapeText(product.model)}</p><div class="sc-product-specs">${[...product.finish, ...product.mounting].map((value) => `<span>${escapeText(value)}</span>`).join('')}</div><p class="sc-product-status">${escapeText(labels.preview_product)}</p></div></article>`;
      };
      const render = (writeHash = true) => {
        const terms = normalise(controls.q.value).split(/\s+/).filter(Boolean);
        filtered = products.filter((product) => (!controls.department.value || product.department === controls.department.value) && (!controls.group.value || product.group === controls.group.value) && (!controls.category.value || product.category === controls.category.value) && (!controls.finish.value || product.finish.includes(controls.finish.value)) && (!controls.mounting.value || product.mounting.includes(controls.mounting.value)) && terms.every((term) => product.search.includes(term)));
        filtered.sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }) * (controls.sort.value === 'za' ? -1 : 1));
        const pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
        page = Math.max(1, Math.min(page, pages));
        const start = (page - 1) * PAGE_SIZE;
        root.querySelector('[data-products]').innerHTML = filtered.slice(start, start + PAGE_SIZE).map(productCard).join('');
        root.querySelectorAll('.sc-product-image img').forEach((img) => img.addEventListener('error', () => { const text = document.createElement('span'); text.textContent = labels.product_image_missing; img.replaceWith(text); }, { once: true }));
        root.querySelector('[data-result-count]').textContent = format(labels.results, { count: filtered.length.toLocaleString() });
        root.querySelector('[data-range]').textContent = filtered.length ? format(labels.showing, { from: (start + 1).toLocaleString(), to: Math.min(start + PAGE_SIZE, filtered.length).toLocaleString(), count: filtered.length.toLocaleString() }) : '';
        root.querySelector('[data-empty]').hidden = filtered.length > 0;
        root.querySelector('[data-pagination]').hidden = pages <= 1;
        root.querySelector('[data-page]').textContent = format(labels.page, { current: page, total: pages });
        root.querySelector('[data-previous]').disabled = page <= 1;
        root.querySelector('[data-next]').disabled = page >= pages;
        root.querySelectorAll('[data-department]').forEach((link) => link.setAttribute('aria-current', String(link.dataset.department === controls.department.value)));
        const chips = root.querySelector('[data-active-filters]');
        chips.innerHTML = ['q', 'department', 'group', 'category', 'finish', 'mounting'].filter((name) => controls[name].value).map((name) => {
          const value = name === 'q' ? controls[name].value : controls[name].selectedOptions[0].textContent;
          return `<button type="button" data-remove-filter="${name}" aria-label="${escapeText(labels.close)}: ${escapeText(value)}">${escapeText(value)} <span aria-hidden="true">×</span></button>`;
        }).join('');
        if (writeHash) setHash();
      };
      const restoreHash = () => {
        const params = new URLSearchParams(location.hash.slice(1));
        controls.department.value = params.get('department') || '';
        controls.group.value = '';
        controls.category.value = '';
        updateFacets();
        controls.group.value = params.get('group') || data.categories.find((category) => category.id === params.get('category'))?.group || '';
        updateFacets();
        controls.category.value = params.get('category') || '';
        updateFacets();
        controls.finish.value = params.get('finish') || '';
        controls.mounting.value = params.get('mounting') || '';
        controls.q.value = params.get('q') || '';
        controls.sort.value = params.get('sort') === 'za' ? 'za' : 'az';
        page = Math.max(1, Number.parseInt(params.get('page'), 10) || 1);
        render(false);
      };
      const reset = () => { Object.values(controls).forEach((control) => { control.value = ''; }); controls.sort.value = 'az'; page = 1; updateFacets(); render(); };
      form.addEventListener('submit', (event) => event.preventDefault());
      form.addEventListener('change', (event) => { page = 1; if (event.target.name === 'department') { controls.group.value = ''; controls.category.value = ''; } if (event.target.name === 'group') controls.category.value = ''; updateFacets(); render(); });
      let timer;
      controls.q.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => { page = 1; render(); }, 160); });
      form.addEventListener('reset', (event) => { event.preventDefault(); reset(); });
      root.querySelector('[data-reset]').addEventListener('click', reset);
      root.querySelector('[data-active-filters]').addEventListener('click', (event) => { const button = event.target.closest('[data-remove-filter]'); if (!button) return; controls[button.dataset.removeFilter].value = ''; if (button.dataset.removeFilter === 'department') { controls.group.value = ''; controls.category.value = ''; } if (button.dataset.removeFilter === 'group') controls.category.value = ''; page = 1; updateFacets(); render(); });
      root.querySelectorAll('[data-department]').forEach((link) => link.addEventListener('click', (event) => { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); controls.department.value = link.dataset.department; controls.group.value = ''; controls.category.value = ''; controls.finish.value = ''; controls.mounting.value = ''; controls.q.value = ''; page = 1; updateFacets(); render(); root.querySelector('[data-browser]').scrollIntoView({ behavior: 'auto', block: 'start' }); }));
      root.querySelector('[data-groups]').addEventListener('click', (event) => { const button = event.target.closest('[data-group]'); if (!button) return; controls.group.value = controls.group.value === button.dataset.group ? '' : button.dataset.group; controls.category.value = ''; controls.finish.value = ''; controls.mounting.value = ''; page = 1; updateFacets(); render(); root.querySelector('[data-filters]').scrollIntoView({ behavior: 'auto', block: 'start' }); });
      const turnPage = (offset) => { page += offset; render(); root.querySelector('[data-result-count]').scrollIntoView({ behavior: 'auto', block: 'start' }); };
      root.querySelector('[data-previous]').addEventListener('click', () => turnPage(-1));
      root.querySelector('[data-next]').addEventListener('click', () => turnPage(1));
      window.addEventListener('hashchange', restoreHash);
      restoreHash();
      loading.hidden = true;
      root.querySelector('[data-browser]').hidden = false;
    } catch (error) { loading.textContent = labels.load_error; root.dataset.ready = ''; }
  };
  const scan = () => document.querySelectorAll('.solulu-catalogue').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solulu-lighting-buy"] && !Shopify.designMode) return;
  try {
    
function initializeLightingBuy(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const syncSelection = () => {
    const input = root.querySelector('input[type="radio"][data-price]:checked');
    if (!input) return;
    root.querySelector('[data-lighting-price]').textContent = input.dataset.price;
    root.querySelector('[data-lighting-selection]').textContent = input.dataset.name;
  };
  root.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"][data-price]')) syncSelection();
  });
  window.addEventListener('pageshow', syncSelection);
  syncSelection();
}
document.querySelectorAll('[data-lighting-buy]').forEach(initializeLightingBuy);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-lighting-buy]').forEach(initializeLightingBuy);
});

  } catch(e) { console.error(e); }
})();
})();
